import React from "react";

class Header extends React.Component {
  render() {
    return (
      <div className={"w-full bg-blue"}>
        <div className={"font-quicksand text-white font-bold text-3xl p-4"}>
          B-RIS
        </div>
      </div>
    )
  }
}

export default Header;